import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import store from '../../../sessionStorage';
import { insAdminUserId } from '../../../utils/Utility';
import whiteLogo from '../../../utils/images/logo-white.png';
/**
 * @package VirtuOwl
 * @type {React.ComponentClass}
 */
class Navigation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userId: '',
        };
    }

    //componentDidMount
    componentDidMount() {
        insAdminUserId((res) => {
            this.setState({
                userId: res,
            });
        });
    }

    render() {
        const { userId } = this.state;
        return (
            <div>
                <aside
                    className={`w-64 bg-emerald transition-all flex flex-col gap-8 xl:relative fixed h-full xl:left-0 z-20 ${
                        this.props.mobileNav ? 'left-0' : '-left-96'
                    }`}
                >
                    <div className="p-4 flex justify-center relative">
                        <img src={whiteLogo} alt="VirtuOwl" className="w-3/4" />
                        <button
                            className="absolute -right-8 block xl:hidden"
                            onClick={() => {
                                this.props.onClickMobileNav(false);
                            }}
                        >
                            <i className="far fa-times text-white text-xl"></i>
                        </button>
                    </div>
                    {this.props.showNavigation && (
                        <nav className="flex flex-col">
                            {this.props.navigationMenu && this.props.navigationMenu.length
                                ? this.props.navigationMenu.map((menu, i) => (
                                      <div key={i}>
                                          {menu.navMenu ? (
                                              store.get('insAdminSession').role !== 'GRA_ADMIN' &&
                                              menu.title === 'Financial Reports' ? (
                                                  <>
                                                      {store.get('insAdminSession')
                                                          .payoutEnabled && (
                                                          <Link
                                                              className={`items-center p-4 font-normal flex gap-4 ${
                                                                  this.props.active === menu.active
                                                                      ? 'bg-light bg-opacity-20 text-white'
                                                                      : 'text-white'
                                                              }`}
                                                              style={
                                                                  !this.props.nav
                                                                      ? { pointerEvents: 'none' }
                                                                      : null
                                                              }
                                                              to={`/${menu.roleType}/${userId}/${menu.active}`}
                                                              key={i}
                                                          >
                                                              <i
                                                                  style={{ marginRight: '0.5rem' }}
                                                                  className={menu.icon}
                                                              />
                                                              <span>{menu.title}</span>
                                                          </Link>
                                                      )}
                                                  </>
                                              ) : (
                                                  <Link
                                                      className={`items-center p-4 font-normal flex gap-4 ${
                                                          this.props.active === menu.active
                                                              ? 'bg-light bg-opacity-20 text-white'
                                                              : 'text-white'
                                                      }`}
                                                      style={
                                                          !this.props.nav
                                                              ? { pointerEvents: 'none' }
                                                              : null
                                                      }
                                                      to={`/${menu.roleType}/${userId}/${menu.active}`}
                                                      key={i}
                                                  >
                                                      {menu.active === 'dashboard' ? (
                                                          <>
                                                              <span
                                                                  style={{ marginRight: '0.25rem' }}
                                                              >
                                                                  <svg
                                                                      xmlns="http://www.w3.org/2000/svg"
                                                                      width="18"
                                                                      height="18"
                                                                      viewBox="0 0 24 24"
                                                                  >
                                                                      <path
                                                                          fill="currentColor"
                                                                          d="M13 9V3h8v6h-8ZM3 13V3h8v10H3Zm10 8V11h8v10h-8ZM3 21v-6h8v6H3Z"
                                                                      />
                                                                  </svg>
                                                              </span>
                                                          </>
                                                      ) : (
                                                          <i
                                                              style={{ marginRight: '0.5rem' }}
                                                              className={menu.icon}
                                                          />
                                                      )}
                                                      <span>{menu.title}</span>
                                                  </Link>
                                              )
                                          ) : null}
                                      </div>
                                  ))
                                : null}
                        </nav>
                    )}
                </aside>
            </div>
        );
    }
}

export default Navigation;

